<form [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>Nome</mat-label>
    <input matInput formControlName="name" placeholder="Digite seu nome">
    @if (form.get('name')?.hasError('required')) {
      <mat-error>Nome é obrigatório</mat-error>
    }
    @if (form.get('name')?.hasError('minlength')) {
      <mat-error>Nome deve ter no mínimo 2 letras</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>E-mail</mat-label>
    <input matInput formControlName="email" placeholder="Digite seu e-mail">
    @if (form.get('email')?.hasError('required')) {
      <mat-error>E-mail é obrigatório</mat-error>
    }
    @if (form.get('email')?.hasError('email')) {
      <mat-error>Digite um e-mail válido</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Senha</mat-label>
    <input matInput type="password" formControlName="password" placeholder="Digite sua senha">
    @if (mode==='create' && form.get('password')?.hasError('required')) {
      <mat-error>Senha é obrigatória</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Confirme a senha</mat-label>
    <input matInput type="password" formControlName="confirmPassword" placeholder="Confirme sua senha">
    @if (mode==='create' && form.get('confirmPassword')?.hasError('required')) {
      <mat-error>Confirmação é obrigatória</mat-error>
    }
    @if (form.hasError('passwordsMismatch')) {
      <mat-error>As senhas não coincidem</mat-error>
    }
  </mat-form-field>

  @if (showTermsAcceptance) {
    <div class="terms-acceptance">
      <mat-checkbox formControlName="acceptedTermsOfUse">
        Declaro que li e aceito os
        <a href="assets/legal/terms-of-use.html" target="_blank" rel="noopener noreferrer">termos de uso</a>
      </mat-checkbox>
      <mat-checkbox formControlName="acceptedPrivacyPolicy">
        Declaro que li e aceito a
        <a href="assets/legal/privacy-policy.html" target="_blank" rel="noopener noreferrer">política de privacidade</a>
      </mat-checkbox>
    </div>
  }
</form>

